import { Nullable } from "features/shared/types/nullable";
import InsertRequirementResultDTO from "../dtos/InsertRequirementResultDTO";

export const REQUIREMENTS_BASE_PATH = "/requirements";
export const REQUIREMENTS_ADMIN_BASE_PATH = "/admin/email-requirements";

export const getRequirementDetailPath = (requirementId: string): string =>
  `${REQUIREMENTS_BASE_PATH}/${requirementId}`;

export const getRequirementAdminDetailPath = (requirementId: string): string =>
  `${REQUIREMENTS_ADMIN_BASE_PATH}/${requirementId}`;

export const getRequirementAdminListPath = (): string => REQUIREMENTS_ADMIN_BASE_PATH;

export const getRequirementsListPath = (): string => REQUIREMENTS_BASE_PATH;

export const resolvePostCreateRoute = (
  result?: InsertRequirementResultDTO
): Nullable<string> => {
  if (!result?.requirementId) {
    return null;
  }

  return getRequirementDetailPath(result.requirementId);
};
